/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelperService } from '../helper/helper.service';
import { ShoppingService } from '../shared/shopping.service';
import { AccountService } from '../user/account.service';
import { tap } from 'rxjs/operators';
import { ApiErrorService } from '../api-error.service';
@Injectable({
  providedIn: 'root',
})
export class CashbackService {
  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  // tslint:disable-next-line: max-line-length
  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private envService: ShoppingService,
    private accountService: AccountService,
    private apiErrorService: ApiErrorService
  ) {
    this.initApiParams();
  }

  initApiParams() {
    this.apiParams = {
      perpage: 10,
      profileid: this.accountService.registered,
    };
  }

  public set appPageApi(value: string) {}

  public get appPageApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.appPageApi = `${this.envService.getAppPageApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set dealDetailApi(value: string) {}
  public get dealDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.dealDetailApi = `${this.envService.getDealDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set couponDetailApi(value: string) {}
  public get couponDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.couponDetailApi = `${this.envService.getCouponDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set productDetailApi(value: string) {}
  public get productDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.productDetailApi = `${this.envService.getProductDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set couponListApi(value: string) {}
  public get couponListApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.couponListApi = `${this.envService.getCouponListApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set browseDataApi(value: string) {}
  public get browseDataApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.browseDataApi = `${this.envService.getBrowseDataApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public getAppPage(
    pageId: number,
    tabId: number,
    sendSelectedTab: number,
    page: number
  ): Observable<any> {
    this.apiParams.pageId = pageId;
    this.apiParams.tabId = tabId;
    this.apiParams.sendSelectedTab = sendSelectedTab;
    this.apiParams.page = page;
    // this.apiParams.cc = 1;
    return this.httpClient.get(this.appPageApi).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => {
          this.apiErrorService.updateValue(true);
        }
      )
    );
  }

  public getDeal(id: string): Observable<any> {
    this.apiParams.id = id;
    return this.httpClient.get(this.dealDetailApi).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => {
          this.apiErrorService.updateValue(true);
        }
      )
    );
  }

  public getCoupon(id: string): Observable<any> {
    this.apiParams.id = id;
    return this.httpClient.get(this.couponDetailApi).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => {
          this.apiErrorService.updateValue(true);
        }
      )
    );
  }

  public getProduct(id: string): Observable<any> {
    this.apiParams.productId = id;
    this.apiParams.category = 'product_id';
    this.apiParams.type = 'json';
    return this.httpClient.get(this.productDetailApi).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => {
          this.apiErrorService.updateValue(true);
        }
      )
    );
  }

  public getCouponList(type: string): Observable<any> {
    this.apiParams.type = type;
    return this.httpClient.get(this.couponListApi).pipe(
      tap(
        (event: HttpEvent<any>) => event,
        (error: any) => {
          this.apiErrorService.updateValue(true);
        }
      )
    );
  }

  public getBrowseData(data: any): Observable<any> {
    return this.httpClient
      .post(this.browseDataApi, data, this.httpOptions)
      .pipe(
        tap(
          (event: HttpEvent<any>) => event,
          (error: any) => {
            this.apiErrorService.updateValue(true);
          }
        )
      );
  }
}
